import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { COMBOS, waLink } from "@/data/site";

// Optionally filter combos by relatedSlug or by ids
const ComboSection = ({ title = "Populaire combo's — meer beleving, meer herinneringen", slug = null, ids = null, dark = false }) => {
  let list = COMBOS;
  if (ids) list = COMBOS.filter((c) => ids.includes(c.id));
  else if (slug) list = COMBOS.filter((c) => c.relatedSlugs?.includes(slug));
  if (!list.length) return null;

  return (
    <section className={`${dark ? "bg-ink text-white" : "bg-beige"} py-24 md:py-32`}>
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="eyebrow mb-4">Combo&apos;s</p>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight">{title}</h2>
          <p className={`mt-5 ${dark ? "text-white/60" : "text-neutral-600"} text-sm max-w-lg mx-auto`}>
            Kies een compleet verhaal — foto&apos;s, Magic Mirror én Audio Gastenboek samen. Meer beleving voor jouw event, en altijd voordeliger.
          </p>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 ${list.length > 2 ? "lg:grid-cols-3" : ""} ${list.length > 3 ? "xl:grid-cols-4" : ""} gap-6`}>
          {list.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Gift;
            return (
              <motion.article
                key={c.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.06 }}
                className={`relative p-8 md:p-10 flex flex-col ${
                  dark
                    ? c.highlight
                      ? "bg-white text-ink"
                      : "bg-white/5 border border-white/10 text-white"
                    : c.highlight
                      ? "bg-ink text-white"
                      : "bg-white text-ink"
                }`}
              >
                {c.savings && (
                  <span className={`absolute top-6 right-6 text-[10px] uppercase tracking-[0.25em] ${c.highlight ? "text-gold" : "text-gold"}`}>
                    {c.savings}
                  </span>
                )}
                <Icon size={22} className="text-gold mb-6" strokeWidth={1.4} />
                <h3 className="font-serif text-2xl md:text-3xl leading-tight">{c.name}</h3>
                <p className="font-serif text-4xl md:text-5xl text-gold mt-4">{c.price}</p>
                <ul className={`mt-6 space-y-2 text-sm ${
                  c.highlight
                    ? dark ? "text-neutral-600" : "text-white/85"
                    : dark ? "text-white/75" : "text-neutral-600"
                }`}>
                  {c.items.map((it) => (
                    <li key={it} className="flex items-start gap-2">
                      <Check size={13} className="text-gold mt-1 shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
                {c.extraOption && (
                  <p className={`mt-3 text-xs italic ${
                    c.highlight
                      ? dark ? "text-neutral-500" : "text-white/60"
                      : dark ? "text-white/50" : "text-neutral-500"
                  }`}>
                    + {c.extraOption}
                  </p>
                )}
                {c.extraBonus && (
                  <p className="mt-4 text-[10px] uppercase tracking-[0.25em] text-gold">
                    + Extra bonus: {c.extraBonus}
                  </p>
                )}
                <div className="mt-8">
                  <a
                    data-testid={`combo-book-${c.id}`}
                    href={waLink(`Hallo Eric, ik wil graag info over de ${c.name}.`)}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-gold px-6 py-3 text-[10px]"
                  >
                    Vraag info
                  </a>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ComboSection;
